<template>
  <div>
    <v-dialog :value="value" persistent max-width="600px">
      <nv-form
        v-if="item != null"
        :errors="formErrors"
        :loading="loading"
        title="Create Rules"
        data-cy="bulk-ua-form"
        @cancel="formCancel"
        @nv-submit="formSubmit"
      >
        <v-row>
          <v-col cols="12">
            <app-dict-search
              v-if="value"
              ref="appDictSearch"
              v-model="item.app_dictionary_id"
              :rules="rules.application"
            />
          </v-col>
          <v-col cols="12">
            <owl-date-picker v-model="item.effective_start_date" label="Start Date" />
          </v-col>
        </v-row>
      </nv-form>
    </v-dialog>
    <bulk-classify-failures-dialog
      v-model="failuresDialog.show"
      :failures="failuresDialog.failures"
      @saved="$emit('saved')"
    />
  </div>
</template>

<script>
import HTTP from '@/api/ant';
import { FormMixin } from '@nielsen-media/ui-toolkit-vue-api';
import AppDictSearch from '@/components/mv/AppDictSearch';
import OwlDatePicker from '@/components/OwlDatePicker';
import BulkClassifyFailuresDialog from '@/components/cls/ios/BulkClassifyFailuresDialog';
import Rules from 'bsm-validation-rules';
import { sendIosAppBulkShadowEvaluation } from '@/helpers/iosAppShadowApi';

const rules = {
  application: [Rules.presence()],
};

export default {
  components: { OwlDatePicker, AppDictSearch, BulkClassifyFailuresDialog },
  mixins: [FormMixin],
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    rules,
    failuresDialog: {
      show: false,
      failures: [],
    },
  }),
  methods: {
    formInit() {
      return {
        discovery_ids: this.selectedIds,
        app_dictionary_id: null,
      };
    },
    formSave() {
      return this.submitForm(HTTP, '/ios/ua/discoveries/rules/bulk', {
        success() {
          this.$flash('success', `Create Rule Proposals successfully created`);
        },
      });
    },
    sendBulkShadowEvaluation() {
      const appSearch = this.$refs.appDictSearch;
      const applicationName = appSearch?.selected?.name || '';

      sendIosAppBulkShadowEvaluation({
        discoveries: this.selectedItems,
        expectedApplicationId: this.item.app_dictionary_id,
        expectedApplicationName: applicationName,
      });
    },
    formSubmit(form) {
      const elem = form || this.formElement();
      if (elem != null && elem.validate()) {
        this.loading = true;

        // Fire-and-forget shadow evaluation alongside the bulk classify
        try {
          this.sendBulkShadowEvaluation();
        } catch (error) {
          console.error('[iOS Bulk Shadow] Failed to send shadow evaluation:', error);
        }

        this.formSave()
          .then(current => {
            this.$emit('saved', {
              current,
              previous: this.editing,
            });
            this.formCancel(form);
          })
          .catch(err => {
            const failures = err.response?.data?.errors?.failures;
            if (failures?.length) {
              this.failuresDialog.failures = failures;
              this.formCancel(form);
              this.failuresDialog.show = true;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
